import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import { FormField } from '@angular/forms/signals';

import { TranslatePipe } from '@ngx-translate/core';

import type { TabForm, TabFormModel } from '@sites/entity-signal-form';

import { SettingsBreadcrumbsComponent } from '@web/shared/components/web-settings/settings-breadcrumbs/settings-breadcrumbs.component';
import { SettingsFooterComponent } from '@web/shared/components/web-settings/settings-footer/settings-footer.component';

import { AbstractSignalSettingsComponent } from '../../abstract-base-settings/abstract-signal-settings.component';

@Component({
    selector: 'web-tab-item-settings',
    templateUrl: './tab-item-settings.component.html',
    styleUrls: ['./tab-item-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [A11yModule, SettingsBreadcrumbsComponent, TranslatePipe, SettingsFooterComponent, FormField],
})
export class TabItemSettingsComponent extends AbstractSignalSettingsComponent<TabFormModel> {
    public readonly tabIndex = input.required<number>();
    public readonly form = input.required<TabForm>();

    protected readFormValue(): TabFormModel {
        return this.form().value();
    }

    protected writeFormValue(value: TabFormModel): void {
        this.form().setValue(value);
    }

    public readonly titleField = computed(() => this.form().tabTitle(this.tabIndex()));
}
